import { render, staticRenderFns } from "./onIndi.vue?vue&type=template&id=7315d80c"
import script from "./onIndi.vue?vue&type=script&lang=js"
export * from "./onIndi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports